import { CallMethodEnums } from '@/types/api';
import { AuditLogsListReq, AuditLogsListRes } from '@/types/auditLogs';

import { call } from './utils';

export const auditLogsGet = async( args: AuditLogsListReq ): Promise<AuditLogsListRes> => {
  return call<AuditLogsListReq, AuditLogsListRes>( {
    body: {
      action: args.action,
      from_timestamp: args.from_timestamp,
      level: args.level,
      limit: args.limit ?? 100,
      offset: args.offset ?? 0,
      org_id: args.org_id,
      resource_type: args.resource_type,
      status: args.status,
      to_timestamp: args.to_timestamp,
      user_id: args.user_id
    },
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/audit'
  } );
};
